import React from 'react'
import {Button, Modal} from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import PropTypes from 'prop-types'

import {EmailContext} from '../context/EmailContext'

import Collaboration from './Collaboration'

export default class ConsultationModal extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.state = {
      show: this.props.show
    }
  }

  render() {
    const title = this.props.title +
      (isNaN(this.props.questionid) ?
        ' extra vragen ' :
        ' vraag ' + (this.props.questionid - 3))
    const columns = [
      {
        dataField: 'button',
        text: ' ',
        formatter: this.props.checkboxformatter
      },
      {
        dataField: 'fullName',
        text: 'Medewerker',
        sort: true,
        headerFormatter: Collaboration.headerFormatter,
        formatter: Collaboration.contentFormatter
      },
      {
        dataField: 'email',
        text: 'E-mail',
        sort: true,
        headerFormatter: Collaboration.headerFormatter,
        formatter: Collaboration.contentFormatter
      }
    ]
    return (
      <div key={title}>
        <EmailContext.Consumer>
          {ctx => {
            return ctx.state.isFeedbackSent ?
              (<Button className="trigger-link" onClick={this.props.triggerresponsesmodal}>Bekijk antwoorden</Button>) :
              (<Button className="trigger-link" onClick={this.props.triggercollaboratorsmodal}>Wijzig
                medewerkers</Button>)
          }}
        </EmailContext.Consumer>
        <Modal
          {...this.props}
          show={this.props.show}
          onHide={this.props.cancel}
          dialogClassName="custom-modal consultation-modal table-page scans new-scan"
          backdrop={false}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg">
              {title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="user-table">
              <BootstrapTable
                id={this.props.id}
                keyField={this.props.keyfield}
                data={this.props.data}
                columns={columns}
                bordered={false}
                striped
                hover
                condensed
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="primary" onClick={this.props.save}>Opslaan</Button>
            <Button onClick={this.props.cancel}>Annuleren</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

ConsultationModal.PopTypes = {
  show: PropTypes.bool,
  optionalFunc: PropTypes.func,
  save: PropTypes.func,
  cancel: PropTypes.func,
  triggercollaboratorsmodal: PropTypes.func,
  triggerresponsesmodal: PropTypes.func,
  checkboxformatter: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/ConsultationModal.js